/**
 * This script handles sticky behavior and shrink effect on scroll for desktop sub header
 */

const HeaderDesktopSub = {
  cfg: {
    header: document.querySelector('.c-header-desktop-sub'),
    wrapper: document.querySelector('.c-header-desktop-sub__wrapper'),
    logoLink: document.querySelector('.c-header-desktop-sub__logo-link'),
    menuList: document.querySelector('.c-header-desktop-sub__menu-list'),
    shrinkClass: '--shrunk',
    stickyClass: '--sticky',
    scrollThreshold: 100, // pixels to scroll before shrink effect
    resizeThrottle: null,
    scrollThrottle: null
  },

  /**
   * Initialize.
   */
  init() {
    if (!this.cfg.header) return;

    // Set initial state
    this.checkScroll();

    // Add scroll event listener with throttling
    window.addEventListener('scroll', () => {
      this.throttleScroll();
    });

    // Add resize listener for recalculations
    window.addEventListener('resize', () => {
      this.throttleResize();
    });
  },

  /**
   * Throttled scroll handler
   */
  throttleScroll() {
    if (!this.cfg.scrollThrottle) {
      this.cfg.scrollThrottle = setTimeout(() => {
        this.checkScroll();
        this.cfg.scrollThrottle = null;
      }, 10); // 10ms throttle for smooth performance
    }
  },

  /**
   * Throttled resize handler
   */
  throttleResize() {
    if (!this.cfg.resizeThrottle) {
      this.cfg.resizeThrottle = setTimeout(() => {
        // Re-evaluate sticky state on resize
        this.checkScroll();
        this.cfg.resizeThrottle = null;
      }, 150);
    }
  },

  /**
   * Check scroll position and apply classes
   */
  checkScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    const { header, shrinkClass, stickyClass, scrollThreshold } = this.cfg;

    // Always make header sticky when scrolled past 1px
    if (scrollY > 1) {
      header.classList.add(stickyClass);
    } else {
      header.classList.remove(stickyClass);
    }

    // Apply shrink effect when scrolled past threshold
    if (scrollY > scrollThreshold) {
      header.classList.add(shrinkClass);
    } else {
      header.classList.remove(shrinkClass);
    }
  }
};

export default HeaderDesktopSub;
